import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { NotificationButton } from './NotificationButton/NotificationButton';
import { NotificationsWidget } from './NotificationsWidget/NotificationsWidget';

export const Notifications = () => {
  const { introducerId, hasProductsForApplication } = useIntroducerContext();

  if (!introducerId || !hasProductsForApplication)
    return <NotificationButton />;
  return <NotificationsWidget introducerId={introducerId} />;
};
